import RolesHistory from '@/app/roles-history'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { rolesHistoryQueryOptions } from '@/hooks/useRolesQuery'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <RolesHistory />
}

export const Route = createFileRoute('/_auth/_withProject/roles-history')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Rol')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context
  
    await queryClient.prefetchQuery(rolesHistoryQueryOptions)
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})

